import { useGetCreatorOnboardingChecklistQuery } from "src/gql/codegen/duneGraphql";
import dunegql from "src/utils/dunegqlCodegen/dunegql";
import type { Session } from "src/utils/users/types";

export function useGetCreatorOnboardingChecklist(session?: Session) {
  const { data } = useGetCreatorOnboardingChecklistQuery({
    skip: session?.user === undefined,
    context: { session },
    variables: {
      userId: session!.user!.id,
    },
  });

  const checklist = data?.creatorOnboardingChecklist;
  if (checklist === undefined || checklist.dismissedAt !== null) {
    return undefined;
  }

  return checklist;
}

dunegql`
  query GetCreatorOnboardingChecklist($userId: Int!) {
    creatorOnboardingChecklist(userId: $userId) {
      userId
      querySavedAt
      visualizationCreatedAt
      visualizationSharedAt
      dismissedAt
    }
  }
`;
